export default __webpack_public_path__ + "static/media/confrence.4fb954bf.jpg";